import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";

/**
 * Routes that exist so the shape of the product can be argued with in August
 * rather than in November.
 *
 * Every one is an honest empty state. No invented vendor balances, no
 * plausible-looking invoice rows, no sample payments -- this is a system
 * people will make payment decisions from, and scaffolding is fine where
 * fiction is not.
 *
 * These used to carry a paragraph each explaining the design intent of a page
 * that does not exist, and seven rows in the sidebar to reach them. The intent
 * is recorded in BUILD_PLAN.md, which is where it belongs and where it is
 * actually maintained; what a placeholder screen owes the reader is its name,
 * what it will hold, and what it is waiting on.
 *
 * ⚠️ **Six became two on 2026-09-04, and one on 2026-10-08.** Vendors,
 * Invoices, Approvals and Payments were built for real first; Obligations
 * followed once Sarah settled what counts (059). Reconciliation is the one
 * still here, because it names a dependency on somebody else's clock -- the
 * QuickBooks connection -- and a screen that guessed at it would be fiction
 * rather than scaffolding.
 */
export interface ScaffoldSpec {
  path: string;
  title: string;
  what: string;
  waitingOn: string;
}

export const SCAFFOLDS: ScaffoldSpec[] = [
  {
    path: "/reconciliation",
    title: "Reconciliation",
    what: "Bank against the books",
    waitingOn: "the QuickBooks connection · Delivery 3",
  },
];

export default function Scaffold({ title, what, waitingOn }: ScaffoldSpec) {
  return (
    <div className="page">
      <PageHeader title={title} sub={what} />

      <div className="card">
        <div className="state">
          <div className="headline">Not built yet</div>
          <div style={{ marginTop: 12 }}>
            <span className="pill undecided">Waiting on {waitingOn}</span>
          </div>
          <div style={{ marginTop: 14 }}>
            <Link className="button" to="/">
              Back to the dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
